import { useState } from 'react';
import type { DetailRow, PaneData } from '../../shared/contracts';
import type { PaneDescriptor } from '../../shared/pane-catalog';
import { PaneLoader } from './PaneLoader';
import { DrillModal } from './DrillModal';
import { OpslagModal } from './OpslagModal';
import { paneSpan, spanClass } from '../lib/layout';

interface DrillState {
  pane: PaneData;
  bucket?: string;
}

/** Dense grid of independently-loading panes with shared drill-down + opslag modals. */
export function PaneGrid({ descriptors }: { descriptors: PaneDescriptor[] }) {
  const [drill, setDrill] = useState<DrillState | null>(null);
  const [opslag, setOpslag] = useState<DetailRow | null>(null);
  return (
    <>
      {/* No dense flow and no odd 3-column step: visual order always matches catalog
          order. Spans are chosen so 2- and 4-column grids tile without holes. */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {descriptors.map((d) => (
          <div key={d.id} className={spanClass(paneSpan(d))}>
            <PaneLoader descriptor={d} onDrill={(pane, bucket) => setDrill({ pane, bucket })} onOpslag={setOpslag} />
          </div>
        ))}
      </div>
      {drill && (
        <DrillModal
          pane={drill.pane}
          bucket={drill.bucket}
          onClose={() => setDrill(null)}
          onOpslag={(row) => {
            setDrill(null);
            setOpslag(row);
          }}
        />
      )}
      {opslag && <OpslagModal row={opslag} onClose={() => setOpslag(null)} />}
    </>
  );
}
